import * as React from "react";
const SvgFacebook = () => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m13.312 28-.03-10.91H9.5v-4.363h3.782V10c0-4.049 2.173-6 5.303-6 1.5 0 2.788.129 3.164.186v4.232h-2.171c-1.703 0-2.032.934-2.032 2.304v2.005H22.5l-1.89 4.364h-3.064V28z"
  }
));
export default SvgFacebook;
